import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { BackButton } from '../../../../components/UI/ComponentsUI';
import { translate, formatData } from '../../../../utils/util';

const ListCimFileItemDetails = (props) => {
    const item = props.record || {};

    const formatJson = (jsonText) => {
        try {
            return JSON.stringify(JSON.parse(jsonText), null, 2);

        } catch (error) {
            return jsonText;
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container">
                <div className="card">
                    <div className="card-content" style={{ padding: '5px' }}>
                        <div className="row" style={{ marginBottom: '0' }}>
                            <div className="subtitle col s12" style={{ padding: '0px' }}>
                                <span className="field f-1r">{translate("record-details", "expedition:picking")}</span>
                            </div>
                            <div className="row">
                                <div className="input-field no-padding col s6">
                                    <span className="field f-1r">{item?.fileName}</span>
                                    <label className="active" htmlFor="entryCode">{translate('archive-name', 'expedition:picking')}</label>
                                </div>
                                <div className="input-field no-padding col s4">
                                    <span className="field f-1r">{item?.createdBy} - {item.createdByDesc}</span>
                                    <label className="active">{translate('createdBy', 'expedition:picking')}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field no-padding col s6">
                                    <span className="field f-1r" style={{ padding: '0px', wordWrap: 'break-word' }}>{item?.supplier}</span>
                                    <label className="active">{translate("supplier", "expedition:picking")}</label>
                                </div>
                                <div className="input-field no-padding col s4">
                                    <span className="field f-1r" style={{ padding: '0px', wordWrap: 'break-word' }}>{item?.causal}</span>
                                    <label className="active">{translate("movementType", "expedition:picking")}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field no-padding col s6">
                                    <span className="field f-1r" style={{ padding: '0px', wordWrap: 'break-word' }}>{item?.expeditionCode}</span>
                                    <label className="active">{translate("expeditionCode", "expedition:picking")}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field no-padding col s12"  >
                                    <span className="field f-1r">{formatData(item?.createdOn || '')}</span>
                                    {
                                        item?.success ? <label className="active">{translate("success-send", "expedition:picking")}</label>
                                            : <label className="active">{translate("error-send", "expedition:picking")}</label>
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field no-padding col s12">
                                    <pre className="field f-1r" style={{ padding: '0px' }}>{formatJson(item?.jsonRequest)}</pre>
                                    <label className="active" htmlFor="nivel">JSON</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field no-padding col s12">
                                    <pre className="field f-1r" style={{ padding: '0px' }}>{formatJson(item?.jsonResponse)}</pre>
                                    <label className="active" htmlFor="nivel">{translate('response', 'expedition:picking')}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        record: state.pickingReducer.cimFileItem
    };
};

const mapDispatchToProps = () => {
    return {
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListCimFileItemDetails)));
